module.exports = __webpack_public_path__ + "fonts/montserrat-bold.cf3a2eae.ttf";